import http from './http';

export const UploadImage = (apiHost, accessToken, tokenType, file) => {
  const formData = new FormData();
  formData.append('file', file.file);
  return http(apiHost, accessToken, tokenType, { 'Content-Type': 'multipart/form-data' })
    .post('/api/web/media/manage/upload', formData)
};
